import axios from "axios";
import { headers } from "./GeneralService";

export async function getMaqta(props) {
  //   const url = `${process.env.REACT_APP_API_URL}syspro-web-api/v1/get-entity`;
  // const url = `http://localhost:8080/v1/coord/set`;
  const url = `https://gongaji-mushaf-service-m3gra3glsq-et.a.run.app/v1/maqta/get`;

  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        // headers: headers(),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Version: "V3",
          Authorization: `Bearer ${props.bearertoken}`,
        },
        params: {
          maqta_page: props.page.page_id,
        },
      })
      .then((response) => {
        console.log("SUCCESS [MAQTA]");
        resolve(response.data);
      })
      .catch((error) => {
        console.log(error);
        console.log("ERROR [MAQTA]");
        reject(error);
      });
  });
}
